/**
 *
 * @returns Services for determining the site specific asssets based on domain
 */
const getSite = function () {
  const host = location.hostname
  if (location.host.match('pethau')) {
    return {
      id: 'pethau',
      title: 'Pethau IoT',
      logo: 'logo-light.svg',
      icons: 'pethau',
      host: host,
      apiBaseUrl: 'https://api.pethau.io',
      ws: 'wss://websockets.pethau.io/ws'
    }
  } else if (host === 'demo.evometric.cloud') {
    return {
      id: 'demo',
      title: 'EvoMetric IoT (Demo)',
      logo: 'logo-light.svg',
      icons: 'evometric',
      host: host,
      apiBaseUrl: 'https://api.evometric.cloud',
      ws: 'ws://localhost:9001'
    }
  } else if (host === 'evometric.cloud' || host.match('.*\\.evometric\\.cloud')) {
    return {
      id: 'evometric',
      title: 'EvoMetric IoT',
      logo: 'logo-light.svg',
      icons: 'evometric',
      host: host,
      apiBaseUrl: 'https://api.evometric.cloud',
      ws: 'wss://websockets.pethau.io/ws'
    }
  } else if (location.host.match('.*local.*')) {
    return {
      id: 'localhost',
      title: 'EvoMetric IoT (Dev)',
      logo: 'logo-light.svg',
      icons: 'evometric',
      host: host,
      apiBaseUrl: 'http://localhost:8082',
      ws: 'ws://localhost:9001'
    }
  } else {
    return {
      id: 'unknown',
      title: 'IoT Unknown',
      logo: 'logo-light.svg',
      icons: 'default',
      host: host,
      apiBaseUrl: null,
      ws: 'ws://localhost:9001'
    }
  }
}

export const site = getSite()

if (window) {
  window.pethauSite = site
}

if (document) {
  document.title = site.title

  try {
    var favicon = document.getElementById('favicon')
    if (favicon) {
      favicon.setAttribute('href', '/icons/' + site.icons + '/favicon-96x96.png')
    }

    document.querySelectorAll('link[rel="apple-touch-icon"], link[rel="icon"]').forEach(function (el) {
      el.href = el.href.replace('default', site.icons)
    })
  } catch (err) {
    console.log(err)
  }
}
